// Common required field message - shown in header when there are validation errors
export const REQUIRED_FIELD_MESSAGE = "Please Enter Required Information";

export const VALIDATION_MESSAGES = {
  firstName: {
    required: "Please enter a valid first name",
    minLength: "Minimum 2 characters required",
    invalid: "Only letters, spaces, hyphens, and apostrophes are allowed",
    consecutiveHyphens: "Consecutive hyphens are not allowed",
    maxLength: "Maximum 100 characters allowed",
  },
  middleName: {
    minLength: "Minimum 2 characters required",
    invalid: "Only letters, spaces, hyphens, and apostrophes are allowed",
    consecutiveHyphens: "Consecutive hyphens are not allowed",
    maxLength: "Maximum 100 characters allowed",
  },
  lastName: {
    required: "Please enter a valid last name",
    minLength: "Minimum 2 characters required",
    invalid: "Only letters, spaces, hyphens, and apostrophes are allowed",
    consecutiveHyphens: "Consecutive hyphens are not allowed",
    maxLength: "Maximum 100 characters allowed",
  },
  email: {
    required: "Please enter a valid email",
    invalid: "Please enter a valid email",
    // Note: the max-length error message for email is built inline by validateProfileData
    // because the cap is mode-dependent (PROFILE_FIELD_MAX_LENGTHS.EMAIL for standard email,
    // PROFILE_FIELD_MAX_LENGTHS.GROUP_EMAIL for group email mode — LPC-10924).
  },
  groupName: {
    required: "Please enter a group name",
    maxLength: "Maximum 40 characters allowed",
  },
  contactNumber: {
    invalid: "Please enter a valid US phone number (e.g., (555) 123-4567)",
    consecutiveHyphens: "Consecutive hyphens are not allowed",
    minLength: "Please enter a valid 10-digit US phone number",
    maxLength: "Maximum 20 characters allowed",
  },
  stateProvince: {
    invalid: "Please enter a valid US state code (e.g., NY, CA, TX)",
  },
  postalCode: {
    invalid: "Please enter a valid US ZIP code (e.g., 12345 or 12345-6789)",
    maxLength: "Maximum 10 characters allowed",
  },
} as const;

export type ValidationMessages = typeof VALIDATION_MESSAGES;
